
import EventForm from './EventForm'

const AddEvent = () => {
  return (
    <div>
        <EventForm />
    </div>
  )
}

export default AddEvent